import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { useUI } from '../contexts/UIContext';

// 사용자의 화면 권한에 따라 화면 접근을 허용하는 route
const ProtectedRoute = ({ renderComp }) => {
  const { auth } = useApp();
  const { setModalData } = useUI();
  const navigate = useNavigate();

  const businessMappingYn = auth?.memberRoleData?.businessMappingYn;

  useEffect(() => {
    if (businessMappingYn === 'N') {
      setModalData({
        contents: '현재 서비스 이용이 불가능합니다.',
        onClickCloseBtn: () => navigate('/'),
      });
    }
  }, [businessMappingYn, setModalData, navigate]);

  return businessMappingYn === 'Y' ? renderComp : null;
};

export default ProtectedRoute;
